import { Box } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../store'
import reportsSelectors from '../../store/reports/reportsSelectors'
import { openCase } from '../../store/reports/reportsSlice'
import { IGenericObjectStringValue } from '../../types'
import textUtils from '../../utils/textUtils'
import CardTAG from '../CardTAG'
import CaseOverviewSection from '../CaseOverviewSection'
import DividerTAG from '../DividerTAG'
import Dropdown from '../Dropdown'
import { IOptionItem } from '../Dropdown/types'
import ReportSubheader from '../ReportSubheader'
import DataPart from './DataPart'
import { IAnswerFiles } from './types'
import PageBodyLayout from '../PageBodyLayout'

const CaseInvestigation: FC = () => {
  const selectedReportTypes = useSelector(reportsSelectors.reportCaseTypes)
  const selectedReport = useSelector(reportsSelectors?.selectedReport)
  const [answersFiles, setAnswersFiles] = useState<IAnswerFiles[]>([])
  const [caseTypeSections, setCaseTypeSections] = useState<IOptionItem[]>([])
  const dispatch = useDispatch<AppDispatch>()

  const formMethods = useForm<IGenericObjectStringValue>({
    defaultValues: { jumpTo: '' },
    mode: 'onChange',
    shouldFocusError: false,
  })
  const { control, watch } = formMethods
  const jumpToWatchValue = watch('jumpTo')

  useEffect(() => {
    if (jumpToWatchValue) {
      const element: HTMLElement | null = document.querySelector(`#${jumpToWatchValue}`)
      const scrollEl = document.querySelector('.t-page-body')
      if (element && scrollEl) {
        scrollEl.scrollTo({
          behavior: 'smooth',
          top: element.offsetTop - 236,
        })
      }
    }
  }, [jumpToWatchValue])

  useEffect(() => {
    if (selectedReportTypes && selectedReportTypes?.length > 0) {
      const transformedTypesToOptions = selectedReportTypes?.map(type => {
        return {
          label: textUtils.humanize(type?.text),
          value: type?.text,
        }
      })
      setCaseTypeSections(transformedTypesToOptions)
    }
  }, [selectedReportTypes])

  useEffect(() => {
    if (selectedReport)
      dispatch(
        openCase({
          caseId: selectedReport?.id as number,
          caseStatus: selectedReport?.report_status.status as string,
        }),
      )
  }, [])

  return (
    <PageBodyLayout
      className={'t-case-investigation-page'}
      caseSubheader={<ReportSubheader />}
      filterPart={
        <CardTAG title='Case Overview'>
          <div className='t-report-card-top'>
            <Dropdown
              label='Jump to Question'
              control={control}
              fieldName='jumpTo'
              selectedValue={jumpToWatchValue}
              options={caseTypeSections}
              placeholder='Select a Question'
            />
          </div>
          <DividerTAG />
          <Box className='t-page-body-left-scrollable-area'>
            <CaseOverviewSection />
          </Box>
        </CardTAG>
      }
      dataPart={<DataPart answersFiles={answersFiles} setAnswersFiles={setAnswersFiles} />}
    />
  )
}

export default CaseInvestigation
